import { render, staticRenderFns } from "./repairPage.vue?vue&type=template&id=2d1fe84e&scoped=true"
import script from "./repairPage.vue?vue&type=script&lang=js"
export * from "./repairPage.vue?vue&type=script&lang=js"
import style0 from "./repairPage.vue?vue&type=style&index=0&id=2d1fe84e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1fe84e",
  null
  
)

export default component.exports